import React from "react";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";

export function ReferralField({ f, value, onChange }) {
  const v = value ?? (f.type === "checkbox" ? [] : "");
  if (f.type === "heading") return <p className="pt-2 text-base font-bold sm:col-span-2">{f.label}</p>;
  if (f.type === "paragraph") return <p className="text-sm text-muted-foreground sm:col-span-2">{f.label}</p>;
  const wide = ["textarea", "radio", "checkbox"].includes(f.type);
  return (
    <label className={`block text-sm ${wide ? "sm:col-span-2" : ""}`}>
      <span className="font-medium">{f.label}{f.required && " *"}</span>
      {f.type === "textarea" ? <Textarea rows={3} value={v} onChange={(e) => onChange(e.target.value)} className="mt-1" data-testid={`ref-f-${f.key}`} />
        : f.type === "select" ? <select value={v} onChange={(e) => onChange(e.target.value)} className="mt-1 h-10 w-full rounded-[9px] border border-border bg-card px-3" data-testid={`ref-f-${f.key}`}><option value="">Select…</option>{(f.options || []).map((o) => <option key={o}>{o}</option>)}</select>
        : f.type === "radio" ? <div className="mt-1 flex flex-wrap gap-2">{(f.options || []).map((o) => <label key={o} className="flex items-center gap-2 rounded-[9px] border border-border px-3 py-2"><input type="radio" name={f.key} checked={v === o} onChange={() => onChange(o)} data-testid={`ref-f-${f.key}-${o}`} /> {o}</label>)}</div>
        : f.type === "checkbox" ? <div className="mt-1 flex flex-wrap gap-2">{(f.options || []).map((o) => <label key={o} className="flex items-center gap-2 rounded-[9px] border border-border px-3 py-2"><input type="checkbox" checked={v.includes(o)} onChange={(e) => onChange(e.target.checked ? [...v, o] : v.filter((x) => x !== o))} /> {o}</label>)}</div>
        : <Input type={f.type === "phone" ? "tel" : f.type} value={v} onChange={(e) => onChange(e.target.value)} className="mt-1" data-testid={`ref-f-${f.key}`} />}
    </label>
  );
}

export function ReferralAnswers({ template, answers }) {
  const fmtV = (f) => { const a = answers?.[f.key]; return Array.isArray(a) ? a.join(", ") : (a || "—"); };
  return (template?.sections || []).map((s, i) => {
    const fields = s.fields.filter((f) => !["heading", "paragraph"].includes(f.type));
    if (!fields.length) return null;
    return (
      <div key={i} className="text-sm" data-testid={`ref-answers-${i}`}>
        <p className="text-xs font-semibold uppercase text-muted-foreground">{s.title}</p>
        <dl className="mt-1 grid gap-3 sm:grid-cols-2">{fields.map((f) => <div key={f.key} className={f.type === "textarea" ? "sm:col-span-2" : ""}><dt className="text-xs text-muted-foreground">{f.label}</dt><dd className="whitespace-pre-wrap">{fmtV(f)}</dd></div>)}</dl>
      </div>
    );
  });
}
